export default "__VITE_ASSET__QzLB3L_b__"